import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { getPackages } from "../../../Core/Packages/action";
import { putData, getData } from "../../../Core/Projects/action";
import cn from "../../../Utility/utility";
import { changeData, unchangeData } from '../../../Core/ChangeValues/action';
import Card from "./Card";
import Modal from "./Modal";
import verfyImage from "../../../Assets/Images/Verify.svg";
import FullLoading from "../../FullLoading";
import { readPendingPackage, clearPendingPackage } from "../../../Utility/pendingPackage";
import styles from "../../../Assets/Styles/Components/Book/Packages/Packages.module.css";

class Packages extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      activeHour: 0,
      modal: null,
      selectedPack: null,
      applyingPendingPackage: false,
    };
    this.navRef = React.createRef();
    this.hourRef = React.createRef();
    this.topRef = React.createRef();
    // this.scrollToSelectedHour = this.scrollToSelectedHour.bind(this);
    // this.selectPackage = this.selectPackage.bind(this);
  }

  componentDidMount() {
    // document.querySelector(`.${styles.packages}`).scrollIntoView({ behavior: "smooth", });
    if (!this.props.project.slug) {
      if (window.location.search && window.location.search.substr(1)) {
        this.props.getData(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug, {});
        this.props.getPackages(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug);
      }
    }
    if ((this.props.project.slug && this.props.packages && Object.keys(this.props.packages.packages).length === 0) || (this.props.project.slug && this.props.change)) {
      this.props.getPackages(this.props.project.slug);
      this.props.unchangeData();
    }
    if (this.props.project.slug && this.props.packages?.packages?.packages && this.props.packages.packages.packages.length !== 0 && this.props.project.data?.package_id) {
      const res = this.props.packages.packages.packages.filter((i) => {
        return i.id === this.props.project.data.package_id;
      })[0];
      res && this.setState({ activeHour: res.order, selectedPack: res.id });
    }
    this.applyPendingPackage();
  }

  componentDidUpdate(preProps) {
    this.applyPendingPackage();
    if (
      (this.props.project && this.props.project.data && preProps.project.data.step !== this.props.project.data.step) ||
      (this.props.project && !this.props.project.loading && preProps.project.loading !== this.props.project.loading)) {
      this.props.history.push(`/book/${this.props.project.data.step}?slug=${this.props.project.slug}`);
    }
    if (this.props.change !== preProps.change && this.props.project?.data?.package_id && !this.props.packages?.packages && !this.props.packages.loading && this.props.packages?.packages?.packages?.length !== 0) {
      // this.props.getPackages(this.props.project.slug);
      this.setValues();
    }
    if (this.props.project?.data?.package_id && !this.props.project.loading && !this.state.selectedPack && this.props.packages?.packages?.packages && this.props.packages.packages.packages.length !== 0) {
      this.setValues();
    }
  }

  setValues = () => {
    const res = this.props.packages.packages.packages.filter((i) => {
      return i.id === this.props.project.data.package_id;
    })[0];
    res && this.setState({ activeHour: res.order, selectedPack: res.id });
  }

  // The user already chose a package outside /book, so submit it and let the
  // server move them on — Projects::UpdatePackage sets last_step to "date",
  // and componentDidUpdate above follows that. An id that is inactive or
  // belongs to another shoot type is ignored server-side, in which case
  // last_step stays "package" and the cards render as usual.
  //
  // Cleared before submitting so it can only ever fire once: a user who later
  // clicks back to this step from the stepper must be able to change package.
  applyPendingPackage = () => {
    if (this.state.applyingPendingPackage) { return; }
    const { slug, data } = this.props.project;
    if (!slug || !data) { return; }

    const pending = readPendingPackage();
    if (!pending) { return; }
    clearPendingPackage();

    this.setState({ applyingPendingPackage: true });
    this.props.putData(slug, { ...data, package_id: Number(pending), step: 'package' });
    this.props.changeData();
  }

  hourSelection = (hour, e) => {
    this.setState({ activeHour: hour });
    if ((e.pageX - 65) < (window.innerWidth / 2)) {
      this.navRef ? (this.navRef.current.scrollLeft -= 100) : null;
    } else {
      this.navRef ? (this.navRef.current.scrollLeft += 100) : null;
    }
    // this.topRef.current.scrollIntoView({ behavior: "smooth" });
  };

  openFeaturesModal = (res) => {
    this.setState({
      modal: {
        type: 'features',
        ...res,
      }
    });
  }

  openExtensionPricesModal = (res) => {
    this.setState({
      modal: {
        type: 'extension_prices',
        ...res,
      }
    });
  }

  closeModal = () => {
    this.setState({ modal: null });
  }

  render() {
    const { activeHour, selectedPack, modal, applyingPendingPackage } = this.state;
    const { hours, packages: xPackages, recommended_hour, show_average_delivery_count, averages, direct, single_price: singlePrice, extra_price: extraPrice } = this.props.packages.packages;
    // Skipping straight through to the date step — don't flash the cards at a
    // user who already picked a package.
    if (applyingPendingPackage) {
      return <FullLoading />;
    }
    return (
      <>
        <Modal modal={modal} onCloseModal={this.closeModal} />
        <div className="container" ref={this.topRef}>
          <div className="row">
            <div className="col-12">
              <div className="custom-box">
                <div className={styles.packages}>
                  <h4> انتخاب پکیج و مدت رزرو</h4>
                  <div className={styles.selectionBar} ref={this.navRef}>
                    {hours && hours.map((item) => (
                      <div
                        key={item}
                        className={cn(
                          styles.itemSelect,
                          activeHour === item ? styles.active : ""
                        )}
                        onClick={(e) => { this.hourSelection(item, e); }}
                        ref={this.hourRef}
                      >
                        <div
                          className={cn(
                            styles.circle,
                            activeHour === item ? styles.active : ""
                          )}
                        />
                        <div>
                          <p> {item >= 1 ? `${item} ساعت` : `30 دقیقه`} </p>
                          {/* <p>20 تا 30 عکس</p> */}
                          {
                            averages.map((ave) => {
                              return ave.order === item && show_average_delivery_count && <p className={styles.avrs}>{Number(ave.average_frames) >= 10 ? `${Number(Number(ave.average_frames) - 5)} تا ${Number(Number(ave.average_frames) + 5)} فایل` : `میانگین ${Number(Number(ave.average_frames))} فایل`}</p>;
                            })
                          }
                        </div>
                        {item === recommended_hour && <img src={verfyImage} alt="Verify" />}
                      </div>
                    ))}
                  </div>
                  <div className={styles.packagesCards}>
                    {xPackages && xPackages.map((packageData) => (
                      <Card
                        key={packageData.id}
                        direct={direct}
                        activeHour={activeHour}
                        selectedPack={selectedPack}
                        singlePrice={singlePrice}
                        {...packageData}
                        extraPrice={extraPrice}
                        onMore={(e) => { this.openFeaturesModal(e); }}
                        onExtensionPrices={(e) => { this.openExtensionPricesModal(e); }}
                      />
                    ))}
                  </div>
                  <div className={`${styles.options} ${styles.bgBlue}`}>
                    <div className={styles.item}>
                      <p className={styles.notice}>
                        <i className="far fa-eye" /> { }
                        تحویل همه فایل‌ها به شما بدون محدودیت
                      </p>
                    </div>
                    <div className={styles.item}>
                      <p className={styles.notice}>
                        <i className="fas fa-tags" /> { }
                        {" "}امکان تمدید زمان حین عکاسی یا فیلمبرداری .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    packages: state.packages,
    project: state.project,
    change: state.change.change
  };
};
export default connect(mapStateToProps, { getPackages, putData, getData, changeData, unchangeData })(withRouter(Packages));
